import { Error, ErrorType } from '../commonType';
import { v4 as uuidv4 } from 'uuid';

export const NO_OFFER = 'NO_OFFERS';
export const INVALID_PIN = 'INVALID_PIN';
export const OFFER_EXPIRED = 'EXPIRED_OFFERS';
export const INVALID_LOC = 'INVALID_LOC';
export const PIN_UNAVAILABLE = 'PIN_UNAVAILABILITY';
export const UNABLE_TO_CONTACT_PROVIDER = 'UNABLE_TO_CONTACT_PROVIDER';
export const PAYMENT_FAILED = 'PAYMENT_FAILED';
export const PAYMENT_DECLINED = 'PAYMENT_DECLINED';
export const PAYMENT_DONE_BOOKING_FAILED = 'PAYMENT_DONE_BOOKING_FAILED';

export const CREDIT_CARD_DECLINED_GENERIC = 'CREDIT_CARD_DECLINED_GENERIC';

export const MPAS_ERROR = 'MPAS_Error';
export const IIB_ERROR = 'IIB_Error';

export const createError = (errorCode: string): Error => {
  let errorType: ErrorType = ErrorType.Error;
  let errorResourceKey = '';
  switch (errorCode) {
    case NO_OFFER:
      errorResourceKey =
        'preview-sales-engine.static-content.copy.associate-search-page.search-form-errors#nooffersfound';
      break;
    case INVALID_PIN:
      errorResourceKey = 'preview-sales-engine.static-content.copy.associate-search-page.pin-field-errors#pattern';
      break;
    case INVALID_LOC:
      errorResourceKey = 'preview-sales-engine.static-content.copy.associate-search-page.loc-field-errors#pattern';
      break;
    case OFFER_EXPIRED:
      errorResourceKey =
        'preview-sales-engine.static-content.copy.associate-search-page.search-form-errors#alloffersexpired';
      break;
    case PIN_UNAVAILABLE:
      errorResourceKey =
        'preview-sales-engine.static-content.copy.associate-search-page.search-form-errors#generalerror';
      break;
    case MPAS_ERROR:
      errorResourceKey = 'preview-sales-engine.static-content.copy.Error Message.mpas-error';
      break;
    case IIB_ERROR:
      errorResourceKey = 'preview-sales-engine.static-content.copy.Error Message.iib-error';
      break;
    case UNABLE_TO_CONTACT_PROVIDER:
      errorResourceKey = 'preview-sales-engine.static-content.copy.Labels.labels#payment-provider-error-message';
      break;
    case PAYMENT_FAILED:
      errorResourceKey =
        'preview-sales-engine.static-content.copy.Labels.labels#preview-sales-engine.static-content.copy.error.message.payment-failed';
      break;
    case PAYMENT_DECLINED:
      errorResourceKey =
        'preview-sales-engine.static-content.copy.Labels.labels#preview-sales-engine.static-content.copy.error.message.payment-declined';
      break;
    case PAYMENT_DONE_BOOKING_FAILED:
      errorResourceKey =
        'preview-sales-engine.static-content.copy.Labels.labels#preview-sales-engine.static-content.copy.error.message.payment-done-booking-failed';
      break;
    case CREDIT_CARD_DECLINED_GENERIC:
      errorResourceKey = 'preview-sales-engine.static-content.copy.Labels.error-message.credit-card-declined-generic';
      break;
    default:
      errorResourceKey =
        'preview-sales-engine.static-content.copy.associate-search-page.search-form-errors#generalerror';
      break;
  }
  return {
    errorType: errorType,
    errorMessageKey: errorResourceKey,
  };
};
export const formatNumberWithCurrencySymbol = (number: number, locale: string = 'en-US'): string => {
  if (number != null) {
    if (typeof number.toString().toLowerCase() === 'number') {
      return number.toLocaleString(locale, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'USD',
      });
    } else {
      try {
        const tempNumber = parseFloat(number.toString());
        return tempNumber.toLocaleString(locale, {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
          style: 'currency',
          currency: 'USD',
        });
      } catch (e) {
        return '$0.00';
      }
    }
  }
  return '$0.00';
};
export const numberToFixedPosition = (number: number): string => {
  if (number != null) {
    if (typeof number.toString().toLowerCase() === 'number') {
      return number.toFixed(2);
    } else {
      try {
        const temp = parseFloat(number.toString());
        return temp.toFixed(2);
      } catch {
        return '0.00';
      }
    }
  }
  return '0.00';
};
export const numbersWithoutDecimals = (number) => {
  if (number) {
    const dummyString = number.slice(0, number.lastIndexOf('.'));
    return dummyString;
  }
  return 0;
};
export const parseJWT = () => {
  try {
    const token = sessionStorage.getItem('ID_TOKEN');
    if (token) {
      return JSON.parse(atob(token.split('.')[1]));
    } else {
      return undefined;
    }
  } catch {
    return undefined;
  }
};
export const getLoggedinUserName = () => {
  const parsedToken = parseJWT();
  if (parsedToken) {
    return parsedToken['sub'];
  } else {
    return undefined;
  }
};
export const getLoggedinUserFullName = (): string | undefined => {
  const parsedToken = parseJWT();
  if (parsedToken) {
    const lastName = parsedToken['family_name'];
    const firstName = parsedToken['given_name'];
    return firstName && lastName ? `${lastName}, ${firstName}` : undefined;
  } else {
    return undefined;
  }
};
export const getLoggedinUserGroups = (): string[] | undefined => {
  const parsedToken = parseJWT();
  if (parsedToken) {
    const tokenGroups = parsedToken['groups'];
    if (tokenGroups) {
      return tokenGroups.map((e: string) => {
        return e.split(',')[0].split('=')[1].toLocaleLowerCase();
      });
    } else {
      return undefined;
    }
  } else {
    return undefined;
  }
};

export const userInGroup = (allowedGroups: string[]) => {
  const loggedinUserGroups = getLoggedinUserGroups();
  if (loggedinUserGroups) {
    return allowedGroups.some((val) => loggedinUserGroups.includes(val.toLocaleLowerCase()));
  }
  return false;
};
export const clearStorage = () => {
  sessionStorage.removeItem('persist:availabilityDates');
  sessionStorage.removeItem('persist:offerDetails');
  sessionStorage.removeItem('persist:root');
};
export const clearAuthInfoFromStorage = () => {
  sessionStorage.removeItem('API_TOKEN');
  sessionStorage.removeItem('ID_TOKEN');
  sessionStorage.removeItem('REFRESH_TOKEN');
  sessionStorage.removeItem('EXPIRES');
  sessionStorage.removeItem('expires_at');
};

// Utility function to add script in the head of the document
export const loadScriptInHead = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => resolve(script);
    script.onerror = () => reject(false);

    // Prepend the script to the head
    const head = document.head;
    head.insertBefore(script, head.firstChild);
  });
};

export const generateCorrelationId = (): string => uuidv4();
